"use client";

import { ArrowRight, Code, Lightbulb, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhatWeBuild() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const builds = [{
    icon: Code,
    title: "AI-Driven Automation Architecture",
    description: "Custom-built automation systems that eliminate administrative friction and reclaim your time for creativity.",
    link: "/ServicesPage",
    ref: ref1,
    isVisible: isVisible1,
    delay: 0
  }, {
    icon: Zap,
    title: "Masterclass Residency Programs",
    description: "Intensive workshops blending cybersecurity precision with hip-hop artistry to remix your workflow.",
    link: "/ServicesPage",
    ref: ref2,
    isVisible: isVisible2,
    delay: 100
  }, {
    icon: Lightbulb,
    title: "Strategic Automation Audits",
    description: "Deep-dive analysis to identify administrative leaks and design high-ROI efficiency solutions.",
    link: "/AuditPage",
    ref: ref3,
    isVisible: isVisible3,
    delay: 200
  }];
  return <section className="bg-background py-24 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground md:text-5xl">
            What We Build
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {builds.map((build, i) => {
          const Icon = build.icon;
          return <div key={i} data-index={i} ref={build.ref} style={{
            opacity: build.isVisible ? 1 : 0,
            transform: build.isVisible ? "translateY(0)" : "translateY(20px)",
            transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) ${build.delay}ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) ${build.delay}ms`
          }}>
                <Card className="group h-full border-2 border-border/20 bg-background shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:border-border/40 hover:shadow-medium">
                  <CardHeader className="space-y-4">
                    <div className="inline-flex size-14 items-center justify-center rounded-lg bg-primary/10 text-primary transition-all duration-[var(--duration-medium)] group-hover:scale-110 group-hover:bg-primary/20 group-hover:shadow-[0_0_20px_rgba(60,130,246,0.4)]">
                      <Icon className="size-7" />
                    </div>
                    <CardTitle className="text-xl font-bold text-foreground">
                      {build.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground">
                      {build.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter>
                    <Link to={build.link}>
                      <Button variant="outline" className="group/btn w-full border-2 border-primary/30 bg-transparent text-primary transition-all duration-[var(--duration-medium)] hover:scale-[1.04] hover:border-primary hover:bg-primary/10">
                        Learn More
                        <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                      </Button>
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}